module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separator-container",
    style: (("--separator-color: " + _vm.color))
  }, [_c('div', {
    staticClass: "separator"
  }, [_vm._v("❖")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c46850a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/Separator.vue
// module id = 547
// module chunks = 1